export { default } from './RuleConfiguration.component';
export * from './RuleConfiguration.component';
